import { render } from "./IncongruityPage.vue?vue&type=template&id=9d5f1faa"
import script from "./IncongruityPage.vue?vue&type=script&lang=js"
export * from "./IncongruityPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__